module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cn":{"qualityControl":"质量控制","highlyVariableGene":"高变化基因"},"en":{"qualityControl":"Quality Control","highlyVariableGene":"Highly Variable Gene"}}')
  delete Component.options._Ctor
}
